import './signing-area.scss'

import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { faCheck, faEraser } from "@fortawesome/free-solid-svg-icons";

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { FreeDrawingTool } from '@skinsoft/entity-ui/src/condition-report/drawing-toolbox'
import { SIGNATURE_UPDATED } from '../../../../busTopics';

export interface SignatureDrawing {
    canvas: { width: number, height: number },
    signature: any[]
}

@Component({
    props: {
        signature: {
            type: String,
        },
        showSaveButton: {
            type: Boolean,
            default: false,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        }
    },
    template: require('./signing-area.html')
})
export class SigningArea extends ReactiveVue {

    public static readonly DEFAULT_SIGNATURE_CANVAS_WIDTH = 700;
    public static readonly DEFAULT_SIGNATURE_CANVAS_HEIGHT = 300;

    private signature: String
    public $refs: {
        stage: any;
    }

    private shapes: SignatureDrawing = {
        canvas: {
            height: SigningArea.DEFAULT_SIGNATURE_CANVAS_HEIGHT,
            width: SigningArea.DEFAULT_SIGNATURE_CANVAS_WIDTH
        }, signature: []
    };

    // Icons
    private eraseIcon = faEraser;
    private checkIcon = faCheck;

    // Drawing data
    private readonly STROKE_WIDTH = 5;
    private readonly STROKE_COLOR = 'black';
    private configKonva = {
        height: SigningArea.DEFAULT_SIGNATURE_CANVAS_HEIGHT,
        preventDefault: true,
        width: SigningArea.DEFAULT_SIGNATURE_CANVAS_WIDTH,
    }
    private startClick: any = undefined;
    private currentShape: any = undefined;
    private freeDrawingTool: FreeDrawingTool = new FreeDrawingTool(this.STROKE_WIDTH, this.STROKE_COLOR);
    private isDrawing: boolean = false;
    private shapeIndex: number = 0;
    private signatureOk: boolean = false;

    public mounted() {
        const stage = this.$refs.stage.getStage();
        const stageWidth = stage.container().clientWidth;
        stage.width(stageWidth);
        this.shapes.canvas.width = stageWidth
    }

    private saveSignature() {
        this.$emit(SIGNATURE_UPDATED, JSON.stringify(this.shapes))
    }

    private clearSignature() {
        if (!this.isDrawing) {
            this.shapes = this.blankSignatureDrawing()
            this.saveSignature()
        }
    }

    // Drawing methods
    private onTouchStart(event) {
        event.evt.preventDefault()
        event.evt.stopPropagation()
        if (event.currentTarget._pointerPositions) {
            this.startClick = {}
            this.startClick.x = event.currentTarget._changedPointerPositions[0].x;
            this.startClick.y = event.currentTarget._changedPointerPositions[0].y;

            this.currentShape = this.freeDrawingTool.addShape(this.startClick.x, this.startClick.y, this.shapeIndex)
            this.shapes.signature.push(this.currentShape)
            this.shapeIndex++;
            this.isDrawing = true;
        } else {
            this.startClick = undefined
        }
    }

    private onTouchMove(event) {
        event.evt.preventDefault()
        event.evt.stopPropagation()
        if (this.isDrawing && event.currentTarget._changedPointerPositions) {

            const currentX = event.currentTarget._changedPointerPositions[0].x;
            const currentY = event.currentTarget._changedPointerPositions[0].y;

            this.freeDrawingTool.onTouchMove(this.currentShape, currentX, currentY, this.startClick.x, this.startClick.y);
        }
    }

    private onTouchEnd(event) {
        event.evt.preventDefault()
        event.evt.stopPropagation()
        if (this.startClick && event.currentTarget._changedPointerPositions) {

            const endX = event.currentTarget._changedPointerPositions[0].x;
            const endY = event.currentTarget._changedPointerPositions[0].y;
            this.freeDrawingTool.onTouchEnd(this.currentShape, endX, endY, this.startClick.x, this.startClick.y)
            this.currentShape = null;
            this.saveSignature()
        }
        this.isDrawing = false;
    }

    private blankSignatureDrawing(): SignatureDrawing {
        return {
            canvas: {
                height: SigningArea.DEFAULT_SIGNATURE_CANVAS_HEIGHT,
                width: SigningArea.DEFAULT_SIGNATURE_CANVAS_WIDTH,
            },
            signature: []
        } as SignatureDrawing
    }

    @Watch('signature', { immediate: true })
    private onSignerChange(signature) {
        this.shapes = signature ? JSON.parse(signature) : this.blankSignatureDrawing()
        this.shapeIndex = this.shapes.signature.length
        //this.$forceUpdate()
    }

    @Watch('shapes', { immediate: true, deep: true })
    private onShapesChange() {
        this.signatureOk = this.signature.length > 0
    }

}